/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Playground_DescriptionInputs */

const vi_dev_playground_description = /** @type {(inputs: Dev_Playground_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang ví dụ ẩn sau feature flag. Chỉ hiển thị khi cờ "dev-playground" được bật.`)
};

/**

* @param {Dev_Playground_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dev_playground_description = /** @type {((inputs?: Dev_Playground_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Playground_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dev_playground_description(inputs)
});